import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(
  ({ typography, palette }) => ({
    dropdown: {
      width: 300,
      borderRadius: '5px',
      '& .MuiFormControl-root': {
        '& .MuiInputBase-root': {
          backgroundColor: '#F7F7F7',
          borderRadius: 5,
          '&::before': {
            borderBottom: 'none',
          },
          '&::after': {
            display: 'none',
          },
          height: 'auto',
          padding: '15px 65px 15px 13px',
          ' & .MuiInputBase-input': {
            fontSize: '16px',
            padding: 0,
            height: 'auto',
          },
        },
      },
    },
    hideFlag: {
      '& .MuiInputBase-root': {
        paddingLeft: '16px !important',
      },
    },
    outputText: {
      fontSize: '16px',
    },
    labelWrapper: {
      display: 'flex',
      alignitems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    paymentInfo: {
      textAlign: 'center',
      margin: 'auto',
      paddingLeft: 10,
      fontWeight: typography.fontWeightLight,
      color: 'rgb(51, 51, 51, 0.5)',
    },
    chip: {
      '& .MuiChip-root': {
        backgroundColor: palette.primary.main,
        color: 'white',
        fontWeight: typography.fontWeightRegular,
        fontFamiy: typography.fontFamily,
        fontSize: 12,
      },
      '& .MuiSvgIcon-root': {
        color: 'white',
      },
    },
    selectedCheck: {
      color: palette.primary.main,
      marginLeft: 'auto',
      alignSelf: 'center',
    },
  }),
  { name: 'MultiSelectDropDown' },
);

export default useStyles;
